export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[580px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20flat%20lay%20on%20warm%20cream%20linen%2C%20stylish%20leather%20handbag%2C%20delicate%20gold%20tone%20jewelry%2C%20soft%20cashmere%20scarf%20in%20sand%20color%2C%20minimalist%20sunglasses%2C%20natural%20morning%20sunlight%20with%20gentle%20shadows%2C%20editorial%20product%20photography%2C%20neutral%20beige%20and%20warm%20ivory%20tones%2C%20sophisticated%20harmonious%20composition&width=1800&height=800&seq=cta-product-showcase-v3-2026&orientation=landscape"
          alt="Access the complete itaobuyspreadsheet database today"
          title="Get the original itaobuy sheet now - Access full database"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center lg:items-end justify-between gap-8">
            <div className="lg:max-w-[520px] text-center lg:text-left">
              <h2 className="font-heading text-4xl md:text-6xl font-bold text-background-50 leading-[1.08]">
                Start Using<br />
                <span className="italic">itaobuyspreadsheet</span><br />
                Today
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-50/75 leading-relaxed font-label">
                Access the most updated structured shopping spreadsheets and improve your buying efficiency instantly. All categories are one click away on our main platform.
              </p>
            </div>

            <div className="flex flex-col items-center lg:items-end gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center space-x-3 px-8 py-4 bg-background-50 text-foreground-950 font-label font-semibold text-sm rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <span>buy it now</span>
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
              <p className="text-xs text-background-50/50 font-label max-w-[240px] text-center lg:text-right">
                Secure redirect to our main platform. No personal data required.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}